export default __webpack_public_path__ + "static/share-21e1a7ccf4444fe7e8efdf2533aec172.png";